// extracted by mini-css-extract-plugin
export default {"container":"iL-z","topReviewHeading":"jL-z","criticalReview":"kL-z","favorableReview":"lL-z","vsSeparator":"mL-z"};